var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunderbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0932 4.9123H9.08128L11.7897 1.49023C11.8457 1.41777 11.7951 1.3125 11.7035 1.3125H6.46038C6.4221 1.3125 6.38519 1.33301 6.36605 1.36719L2.82366 7.48535C2.78128 7.55781 2.83323 7.64941 2.918 7.64941H5.30237L4.08011 12.5385C4.05413 12.6451 4.18265 12.7203 4.26194 12.6438L12.1684 5.09961C12.2395 5.03262 12.1916 4.9123 12.0932 4.9123Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderbolt);
export default __webpack_public_path__ + "static/media/thunderbolt.25916d742ed6709cdcf5b2c0fa7be768.svg";
export { ForwardRef as ReactComponent };